import { __decorate, __extends } from "tslib";
import { h, CustomElement, element, props } from '@wk/custom-element';
var PlacerComponent = (function (_super) {
    __extends(PlacerComponent, _super);
    function PlacerComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PlacerComponent.prototype.renderCallback = function () {
        var _this = this;
        return (h("div", { className: this.containerClasses, ref: function (el) { return (_this.wrapperRef = el); } },
            h("slot", null)));
    };
    PlacerComponent.prototype.appendToParent = function () {
        var targetElement = this.ownerDocument.querySelector(this.targetElementSelector);
        if (this.wrapperRef && targetElement) {
            this.parentRef = targetElement;
            this.parentRef.appendChild(this.wrapperRef);
        }
    };
    PlacerComponent.prototype.removeFromParent = function () {
        if (this.wrapperRef && this.parentRef) {
            this.parentRef.removeChild(this.wrapperRef);
            this.parentRef = null;
        }
    };
    __decorate([
        props.string
    ], PlacerComponent.prototype, "targetElementSelector", void 0);
    __decorate([
        props.string
    ], PlacerComponent.prototype, "containerClasses", void 0);
    PlacerComponent = __decorate([
        element('wk-placer')
    ], PlacerComponent);
    return PlacerComponent;
}(CustomElement));
export { PlacerComponent };
